import React from 'react';

import { IconButton as MuiIconButton } from '@mui/material';
import { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

export interface IconButtonProps extends Omit<MuiIconButtonProps, 'color'> {
  className?: string;
  color?: 'primary' | 'secondary' | 'highlight';
  key?: string;
  label?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  size?: 'small' | 'medium';
}

const useStyles = makeStyles((theme: Theme) => ({
  highlightIconButton: {
    backgroundColor: theme.palette.primary.main,

    '& svg': {
      color: theme.palette.primary.contrastText,
    },
  },
}));

export function IconButton(props: IconButtonProps): JSX.Element {
  const classes = useStyles();
  const {
    children,
    className = '',
    color = 'primary',
    label = '',
    onClick,
    size = 'medium',
    ...rest
  } = props;

  const getMuiColor = (_color) => (_color === 'highlight' ? 'primary' : _color);

  const iconButtonStyles = clsx(
    'fd-iconbutton',
    className || '',
    color === 'highlight' && classes.highlightIconButton,
  );
  const labelProp = label && { 'aria-label': label };

  return (
    <MuiIconButton
      className={iconButtonStyles}
      color={getMuiColor(color)}
      {...labelProp}
      onClick={onClick}
      size={size}
      tabIndex={0}
      {...rest}
    >
      {children}
    </MuiIconButton>
  );
}
